import { z } from "zod";

export const ReviewStatusSchema = z.enum(["active", "completed", "closed"]);
export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;

export const FilterFormSchema = z.object({
	search: z.string().default(""),
	groupIds: z.string().array().default([]),
	reviewStatus: ReviewStatusSchema.array().default([]),
	dueDateBefore: z.date().nullable().default(null),
	dueDateAfter: z.date().nullable().default(null),
	unassignedForms: z.enum(["some", "none"]).array().default([]),
	externalForms: z.enum(["some", "none"]).array().default([]),
	awaitingApprovalForms: z.enum(["some", "none"]).array().default([]),
	authorProgress: z.enum(["none", "some", "completed"]).array().default([]),
	signerProgress: z.enum(["none", "some", "completed"]).array().default([]),
	overallProgress: z.enum(["none", "some", "completed"]).array().default([]),
});

export type FilterFormSchema = z.infer<typeof FilterFormSchema>;
